module.exports = __webpack_public_path__ + "static/media/desktop-01.bfd47391.png";